import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { AdvancedCommerce } from '../advanced-commerce.namespace';

ICmsContentService.registerConfig({
    id: AdvancedCommerce.ID,
    name: 'Advanced Commerce Configuration',
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'enabled',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Switch Logic',
            default: false,
            labels: {
                true: 'Advanced Commerce Enabled',
                false: 'Advanced Commerce Disabled'
            }
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: '_section-basic-data',
            title: 'Basic data'
        },
        <NICmsContentField.ITextField>{
            key: 'domainKey',
            type: NICmsContentField.EFieldType.text,
            title: 'Domain Key',
            description:
                'After the registration process you will be assigned a domain key, which is a unique, alphanumeric identifier for your store.',
            required: true
        },
        <NICmsContentField.ITextField>{
            key: 'locationKey',
            type: NICmsContentField.EFieldType.text,
            title: 'Location',
            description:
                'Graphene is a SaaS platform with many physical locations. As part of the registration process you will have been assigned a location key.'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: '_section-authentication',
            title: 'Authentication'
        },
        <NICmsContentField.ITextField>{
            key: 'apiKey',
            type: NICmsContentField.EFieldType.text,
            title: 'API Key',
            required: true
        },
        <NICmsContentField.ITextField>{
            key: 'apiSecret',
            type: NICmsContentField.EFieldType.text,
            title: 'API Secret',
            required: true
        },
        <NICmsContentField.ITextField>{
            key: 'languageId',
            type: NICmsContentField.EFieldType.text,
            title: 'Language ID'
        },
        <NICmsContentField.ITextField>{
            key: 'warehouseId',
            type: NICmsContentField.EFieldType.text,
            title: 'Warehouse ID'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: '_section-category',
            title: 'Category data'
        },
        <NICmsContentField.ITextField>{
            key: 'defaultCategoryId',
            type: NICmsContentField.EFieldType.text,
            title: 'Default Category ID',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            key: 'customCategoriesId',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Custom Categories ID',
            itemNameField: 'id',
            itemName: 'Category',
            fields: [
                <NICmsContentField.ITextField>{
                    key: 'id',
                    type: NICmsContentField.EFieldType.text,
                    title: 'id',
                    required: true
                },
                <NICmsContentField.IRelationField>{
                    key: 'categories',
                    type: NICmsContentField.EFieldType.relation,

                    title: 'Categories',
                    options: {
                        title: 'Category',
                        type: 'category',
                        multiple: true
                    }
                }
            ]
        }
    ]
});
